var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./node_modules/has/src/index.js
// module id = 54
// module chunks = 0 1